export default __webpack_public_path__ + "static/media/logo-200.aea9cdf4.png";